import { render, staticRenderFns } from "./RateRecords.vue?vue&type=template&id=7aa52af0&scoped=true&"
import script from "./RateRecords.vue?vue&type=script&lang=js&"
export * from "./RateRecords.vue?vue&type=script&lang=js&"
import style0 from "./RateRecords.vue?vue&type=style&index=0&id=7aa52af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa52af0",
  null
  
)

export default component.exports